export default {
  data() {
    return {
      liveNow: null,
      liveClockTimer: null,
      liveClockStep: 60000,
    }
  },
  computed: {
    siteNow() {
      return this.liveNow ?? this.$store.state.clock_now
    },
  },
  mounted() {
    this.tickLiveClock()
    document.addEventListener('visibilitychange', this.tickLiveClock)
  },
  beforeDestroy() {
    clearTimeout(this.liveClockTimer)
    document.removeEventListener('visibilitychange', this.tickLiveClock)
  },
  methods: {
    tickLiveClock() {
      clearTimeout(this.liveClockTimer)
      if (document.visibilityState === 'hidden') return
      this.liveNow = Date.now() + (this.$store.state.clock_offset || 0)
      this.liveClockTimer = setTimeout(
        this.tickLiveClock,
        this.liveClockStep - (this.liveNow % this.liveClockStep)
      )
    },
  },
}
